import React from "react";
import GoalDispositionPanel from "../GoalDispositionPanel";
import type { GoalDispositionPanelProps } from "../GoalDispositionPanel";

// Re-export shared types for convenience.
export type { TargetAction, Target, Goal, TargetActionState } from "../GoalDispositionPanel";

export interface DeleteGoalPanelProps
  extends Omit<GoalDispositionPanelProps, "variant" | "onSubmit"> {
  /**
   * Called with the resolved action for every target when the user confirms
   * the delete operation.
   */
  onDelete: GoalDispositionPanelProps["onSubmit"];
}

/**
 * Thin wrapper over `GoalDispositionPanel` configured for the delete flow.
 * Drives title → "Delete Goal", primary radio label → "Delete with this goal",
 * and confirm button color → error.
 *
 * @param props - Same as `GoalDispositionPanelProps` with `onDelete` instead of `onSubmit`.
 */
const DeleteGoalPanel: React.FC<DeleteGoalPanelProps> = ({ onDelete, ...rest }) => (
  <GoalDispositionPanel variant="delete" onSubmit={onDelete} {...rest} />
);

export default DeleteGoalPanel;
